import React, { useContext, useEffect } from "react";
import Layout from "../layout/Layout";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Breadcrumb } from "antd";
import UserInfoContent from "../components/user-account-info/UserInfoContent";
import UserInfoHeader from "../components/user-account-info/UserInfoHeader";
import RightPanel from "../components/user-account-info/RightPanel";
import "../assets/css/dynemic-page.css";
import {
  getAccountInfo,
  getUsageDetails,
} from "../actionCreator/commonActionCreator";
import { AuthContext } from "../context/AuthContext";
import { getUserInfo } from "../utils/utils";
import { getToken } from "../utils/auth";

const UserAccountInfo = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useContext(AuthContext);
  const userAccountInfo = getUserInfo();

  useEffect(() => {
    if (isAuthenticated && Object.keys(userAccountInfo).length) {
      dispatch(getUsageDetails(getToken(), userAccountInfo?.subscriberId));
    }
  }, [Object.keys(userAccountInfo).length]);

  return (
    <>
      <Layout>
        <div className="wrapper user-account-info">
          <div className="breadcrumcontainer">
            <Breadcrumb
              items={[
                {
                  title: <Link to="/dashboard-view">Home</Link>,
                },
                {
                  title: "My Account",
                },
              ]}
            />
          </div>
          <div className="row col-md-12">
            <div className="col-md-9">
              {/* <div id="wrapper"> */}
              <UserInfoHeader />
              <UserInfoContent />
              {/* </div> */}
            </div>
            <div className="col-md-3">
              <RightPanel />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};
export default UserAccountInfo;
